var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevalidaHwm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_69",
    "data-name": "Ret\\xE2ngulo 69",
    width: 280.477,
    height: 84.869,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3887",
    "data-name": "Grupo 3887",
    transform: "translate(-4 19.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3890",
    "data-name": "Grupo 3890",
    transform: "translate(6.182 1.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3889",
    "data-name": "Grupo 3889",
    transform: "translate(0 38.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_205",
    "data-name": "Caminho 205",
    d: "M0,210.7v43.272H2.859V213.555H26.84L23.981,210.7Z",
    transform: "translate(0 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_206",
    "data-name": "Caminho 206",
    d: "M76.287,391.671l5.6,8.705h1.02l-6.62-10.29Z",
    transform: "translate(-62.261 -357.105)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M72.992,391.671l5.6,8.705h1.02l-6.62-10.29Z",
    transform: "translate(-59.572 -357.105)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M60.762,367.635l5.6,8.705h1.02l-6.62-10.291Z",
    transform: "translate(-49.59 -337.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_57",
    "data-name": "Ret\\xE2ngulo 57",
    width: 12.496,
    height: 2.859,
    transform: "translate(50.629 15.355)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_58",
    "data-name": "Ret\\xE2ngulo 58",
    width: 18.08,
    height: 2.859,
    transform: "translate(50.606 32.105)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M237.1,213.556V210.7H204.99v43.272h2.859V213.556Z",
    transform: "translate(-167.302 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M510.025,213.556h8.531l.782-2.859H507.166l-3.9,16.857.535,4.771.336,1.359,1.227.021Z",
    transform: "translate(-412.707 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M416.74,213.556l-.661-2.859H403.907l11.837,43.272h2.077l-11.055-40.414Z",
    transform: "translate(-331.213 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_59",
    "data-name": "Ret\\xE2ngulo 59",
    width: 2.859,
    height: 12.496,
    transform: "translate(129.92 30.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M618.361,213.556h15.857l-2.859-2.859H615.5l-8.124,8.124v35.148h2.859V221.68Z",
    transform: "translate(-498.181 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_60",
    "data-name": "Ret\\xE2ngulo 60",
    width: 18.08,
    height: 2.859,
    transform: "translate(159.884 32.105)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M823.536,213.556V210.7H812.369v43.272h2.859V213.556Z",
    transform: "translate(-666.13 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M1038.3,213.556V210.7h-20.938v11.167h2.859v-8.308Z",
    transform: "translate(-834.362 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_61",
    "data-name": "Ret\\xE2ngulo 61",
    width: 2.027,
    height: 2.859,
    transform: "translate(201.795 32.105)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M1025.1,307.922V286.984h-2.859v18.079h-4.886v11.167h2.859v-8.308Z",
    transform: "translate(-834.171 -272.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M1188.452,213.556l-2.859-2.859h-23.981v43.272h2.859V213.556Z",
    transform: "translate(-952.773 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M1245.966,307.922l1.7-1.7V288.687l-1.7-1.7h-1.156v16.377l-1.7,1.7H1237.9v2.859Z",
    transform: "translate(-1015.033 -272.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M1377.584,213.556h15.857l-2.859-2.859h-15.857l-8.124,8.124v35.148h2.859V221.68Z",
    transform: "translate(-1121.089 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_62",
    "data-name": "Ret\\xE2ngulo 62",
    width: 2.859,
    height: 12.496,
    transform: "translate(266.45 30.777)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M123.752,273.281h-8.738l10.776,16.751h-13.5l1.839,2.859h14.517L117.873,276.14h8.738v-18.4l-2.859-2.859Z",
    transform: "translate(-91.646 -246.76)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M23.858,387.687H15.549v2.859H26.716V378.982l-2.859-4.444Z",
    transform: "translate(-12.69 -344.414)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M286.667,234.554H265.728v4.188h2.859v-1.329h20.938V226.246h-2.859Z",
    transform: "translate(-217.942 -223.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_222",
    "data-name": "Caminho 222",
    d: "M249.786,400.868v8.308H220.539v2.859h32.105V400.868Z",
    transform: "translate(-179.991 -365.903)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_223",
    "data-name": "Caminho 223",
    d: "M265.728,318.069v5.584h2.859v-2.725h15.355V309.76h-2.859v8.308Z",
    transform: "translate(-217.92 -291.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_224",
    "data-name": "Caminho 224",
    d: "M479.142,240.244l-3.237-14h-2.2L478.043,245Z",
    transform: "translate(-388.395 -223.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    "data-name": "Caminho 225",
    d: "M499.227,226.246,488.172,266.66h-8.588l.782,2.859h10.665l11.837-43.272Z",
    transform: "translate(-393.336 -223.387)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    "data-name": "Caminho 226",
    d: "M631.236,362.542V377.9h-8.308v2.859h11.167V365.4h6.913v-2.859Z",
    transform: "translate(-510.852 -334.625)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_227",
    "data-name": "Caminho 227",
    d: "M745.119,290.032h-8.308v2.859h11.167V257.742l-2.859-2.859Z",
    transform: "translate(-604.174 -246.76)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_63",
    "data-name": "Ret\\xE2ngulo 63",
    width: 2.859,
    height: 29.247,
    transform: "translate(157.271 2.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_228",
    "data-name": "Caminho 228",
    d: "M857.164,400.868v8.308H827.917v2.859h32.105V400.868Z",
    transform: "translate(-679.141 -365.903)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_229",
    "data-name": "Caminho 229",
    d: "M1109.555,234.554h-4.886v20.938h2.859V237.413h4.886V226.246h-2.859Z",
    transform: "translate(-905.759 -223.387)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_64",
    "data-name": "Ret\\xE2ngulo 64",
    width: 2.027,
    height: 2.859,
    transform: "translate(186.067 11.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_230",
    "data-name": "Caminho 230",
    d: "M1050.987,400.868v8.308h-18.08v2.859h20.938V400.868Z",
    transform: "translate(-847.114 -365.903)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_231",
    "data-name": "Caminho 231",
    d: "M1232.12,274.293v-1.156l-1.7-1.7h-8.069v20.938h2.859v-18.08Z",
    transform: "translate(-1002.283 -260.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_232",
    "data-name": "Caminho 232",
    d: "M1206.407,281.909l-8.124,8.124h-21.123v2.859h23.981l8.124-8.124V257.743l-2.859-2.859Z",
    transform: "translate(-966.478 -246.76)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_233",
    "data-name": "Caminho 233",
    d: "M1504.342,290.032h-8.308v2.859H1507.2V257.742l-2.859-2.859Z",
    transform: "translate(-1226.724 -246.76)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_234",
    "data-name": "Caminho 234",
    d: "M1390.459,362.542V377.9h-8.308v2.859h11.167V365.4h6.913v-2.859Z",
    transform: "translate(-1133.779 -334.625)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_235",
    "data-name": "Caminho 235",
    d: "M130.434,210.7l10.983,10.983V220.3l-9.578-9.608Z",
    transform: "translate(-106.454 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    "data-name": "Caminho 236",
    d: "M737.813,210.7h1.4L748.8,220.3v1.375Z",
    transform: "translate(-604.993 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    "data-name": "Caminho 237",
    d: "M1497.036,210.7l10.983,10.983V220.3l-9.579-9.608Z",
    transform: "translate(-1227.542 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    "data-name": "Caminho 238",
    d: "M1292.046,210.7h1.4l9.578,9.608v1.375Z",
    transform: "translate(-1060.241 -210.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_239",
    "data-name": "Caminho 239",
    d: "M497.291,307.133l2.35.028-1.251-4.779Z",
    transform: "translate(-407.711 -285.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_240",
    "data-name": "Caminho 240",
    d: "M120.663,270.034V267.55l-1.7-1.7H117.8v1.329",
    transform: "translate(-96.145 -255.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_241",
    "data-name": "Caminho 241",
    d: "M87.12,316.442H80.208V319.3h9.771",
    transform: "translate(-65.462 -297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_242",
    "data-name": "Caminho 242",
    d: "M63.294,250.3H55.226v4.188h2.859v-1.329H65",
    transform: "translate(-45.073 -243.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_243",
    "data-name": "Caminho 243",
    d: "M110.245,253.157V252l-1.7-1.7",
    transform: "translate(-88.586 -243.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_244",
    "data-name": "Caminho 244",
    d: "M120.663,281.75H117.8V270.432l2.859,3.17Z",
    transform: "translate(-96.145 -259.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_65",
    "data-name": "Ret\\xE2ngulo 65",
    width: 2.859,
    height: 7.973,
    transform: "translate(10.154 11.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_66",
    "data-name": "Ret\\xE2ngulo 66",
    width: 2.593,
    height: 2.859,
    transform: "translate(13.012 19.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_245",
    "data-name": "Caminho 245",
    d: "M91.8,253.157H96.58l-1.7-2.859H91.8Z",
    transform: "translate(-74.921 -243.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_246",
    "data-name": "Caminho 246",
    d: "M722.357,276.016v-3.88l-1.7-1.7H719.5",
    transform: "translate(-589.896 -259.449)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_247",
    "data-name": "Caminho 247",
    d: "M688.814,306.024v2.725H681.9v2.859h9.771",
    transform: "translate(-559.135 -288.498)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_248",
    "data-name": "Caminho 248",
    d: "M670.955,257.742h5.209v-1.156l-1.7-1.7H668.1l-1.7,1.7v3.88h2.859v-1.022Z",
    transform: "translate(-546.419 -246.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_67",
    "data-name": "Ret\\xE2ngulo 67",
    width: 2.856,
    height: 6.498,
    transform: "translate(120.036 13.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_249",
    "data-name": "Caminho 249",
    d: "M722.376,282.42h-2.854V270.261l2.854,4.436Z",
    transform: "translate(-589.916 -259.31)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_250",
    "data-name": "Caminho 250",
    d: "M1479.919,276.016v-3.88l-1.7-1.7h-1.156",
    transform: "translate(-1211.239 -259.449)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_251",
    "data-name": "Caminho 251",
    d: "M1446.376,306.024v2.725h-6.912v2.859h9.771",
    transform: "translate(-1180.555 -288.498)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252",
    "data-name": "Caminho 252",
    d: "M1428.517,257.742h5.209v-1.156l-1.7-1.7h-6.365l-1.7,1.7v3.88h2.858v-1.022Z",
    transform: "translate(-1167.898 -246.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_68",
    "data-name": "Ret\\xE2ngulo 68",
    width: 2.856,
    height: 6.498,
    transform: "translate(256.057 13.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253",
    "data-name": "Caminho 253",
    d: "M1479.938,282.42h-2.854V270.261l2.854,4.436Z",
    transform: "translate(-1211.259 -259.31)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3888",
    "data-name": "Grupo 3888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254",
    "data-name": "Caminho 254",
    d: "M272.733,41.936h-.969l-1.421,6.881h.517a3.331,3.331,0,0,0,.917-.079,1.776,1.776,0,0,0,1.111-1.411l.8-3.889a2.455,2.455,0,0,0,.065-.527q0-.975-1.02-.975",
    transform: "translate(-221.637 -34.226)",
    fill: "#09d785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255",
    "data-name": "Caminho 255",
    d: "M363.553,41.936h-1.279l-3.733,17.98h1.279q1.266,0,1.576-1.49l3.113-14.987a2.458,2.458,0,0,0,.065-.527q0-.975-1.021-.975",
    transform: "translate(-293.944 -34.226)",
    fill: "#09d785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_256",
    "data-name": "Caminho 256",
    d: "M165.211,74.372l.633-7.988-2.7,7.988Z",
    transform: "translate(-133.751 -54.179)",
    fill: "#09d785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_257",
    "data-name": "Caminho 257",
    d: "M614.236,39.713h-.026q-1.253,0-1.563,1.49L609.354,57.02a2.41,2.41,0,0,0-.065.527q0,.962,1.02.962,1.279,0,1.589-1.49L615.192,41.2a2.451,2.451,0,0,0,.065-.527q0-.949-1.021-.962",
    transform: "translate(-499.516 -32.411)",
    fill: "#09d785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_258",
    "data-name": "Caminho 258",
    d: "M724.755,41.936h-.969l-1.421,6.881h.517a3.333,3.333,0,0,0,.917-.079,1.776,1.776,0,0,0,1.111-1.411l.8-3.889a2.457,2.457,0,0,0,.065-.527q0-.975-1.02-.975",
    transform: "translate(-592.22 -34.226)",
    fill: "#09d785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_259",
    "data-name": "Caminho 259",
    d: "M6.778,0,.249,32.418h155.5L163.092,0Zm9.047,29.895h-4.3l2.312-11.086H11.291L8.979,29.895h-4.3l5.49-26.39h4.3l-2.3,11.086h2.545l2.3-11.086h4.3ZM35.991,20.43l-.736,9.464h-4.34l.426-5.484H28.176l-1.86,5.484H21.989l3.191-9.425L31.328,3.505h5.58ZM56.558,9.213l-.8,3.889a5.731,5.731,0,0,1-3.785,4.64l1.615,12.154H48.9l-.581-11.349h-.232L45.72,29.895h-4.3l5.49-26.39h5.645q4.224.013,4.224,3.783a9.529,9.529,0,0,1-.22,1.925m18.512,0L71.957,24.2q-1.189,5.681-6.6,5.694H59.621l5.49-26.39h5.955q4.224.013,4.224,3.783a9.529,9.529,0,0,1-.22,1.925m25.966,3.757L94.9,29.895H89.32l1.356-14.289L86.1,29.895h-5.58l.9-16.952.736-9.438h4.327L84.748,22.922,91.09,3.505h4.2L93.544,22.922,99.886,3.505h4.34Zm19.146-4.179-3.294,15.818q-1.189,5.694-6.769,5.708-4.586,0-4.585-3.875a9.114,9.114,0,0,1,.207-1.832l3.294-15.818Q110.222,3.1,115.79,3.1q4.6,0,4.6,3.876a9.109,9.109,0,0,1-.207,1.819M138,9.213l-.8,3.889a5.731,5.731,0,0,1-3.785,4.64l1.615,12.154h-4.689l-.581-11.349h-.232l-2.364,11.349h-4.3l5.49-26.39h5.645q4.224.013,4.224,3.783A9.528,9.528,0,0,1,138,9.213m15.283,20.682h-4.6l-1.137-10.519-2.183,10.519h-4.3l5.49-26.39h4.3l-2.183,10.479,5.5-10.479h4.6L151.1,16.7Z",
    transform: "translate(-0.204)",
    fill: "#09d785"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1666",
    "data-name": "Ret\\xE2ngulo 1666",
    width: 285,
    height: 128,
    transform: "translate(4 -19.89)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevalidaHwm);
export default __webpack_public_path__ + "static/media/revalidaHWM.ddde64c3a6bac215865ed199c43f6b8b.svg";
export { ForwardRef as ReactComponent };